import NextLink from "@/components/case-study/common/NextLink";
import AboutSection from "@/components/case-study/roaddy/AboutSection";
import DefineSection from "@/components/case-study/roaddy/DefineSection";
import DesignProcess from "@/components/case-study/roaddy/DesignProcess";
import DesignSection from "@/components/case-study/roaddy/DesignSection";
import HeroSection from "@/components/case-study/roaddy/HeroSection";
import IdeateSection from "@/components/case-study/roaddy/IdeateSection";
import Research from "@/components/case-study/roaddy/Research";
import WireFrame from "@/components/case-study/roaddy/WireFrame";
import Layout from "@/components/layout/Layout";

const Roaddy = () => (
  <Layout
    description="Road Assistance Mobile App developed for iOS & Android by ultroNeous Technologies helps users find the nearest mechanic in case of vehicle breakdown."
    keywords="Roadside Assistance, roadside assistance app, best roadside assistance app, on demand roadside assistance app, app roadside assistance"
    title="Road Assistance Anytime Anywhere through Mobile App | ultroNeous"
  >
    <HeroSection />
    <AboutSection />
    <DesignProcess />
    <Research />
    <DefineSection />
    <IdeateSection />
    <WireFrame />
    <DesignSection />
    <NextLink
      nextImg={"/assets/case-study/next-case-study/kyc.webp"}
      nextLink={"/portfolio/know-your-customer-app-case-study"}
      nextTitle={"Next <br/> case Study"}
    />
  </Layout>
);
export default Roaddy;
